import BestBuyLogo from '../../assets/bestBuyLogo.svg';
import TireAgentLogo from '../../assets/tireAgentLogo.png';

const retailers = [
    {
        id: 'BEST_BUY',
        href: '/shop/?source=BEST_BUY',
        logo: BestBuyLogo,
        alt: 'Best Buy'
    },
    {
        id: 'TIRE_AGENT',
        href: 'https://paytomorrow.tireagent.com/finance',
        logo: TireAgentLogo,
        alt: 'Tire Agent'
    }
];

const PopularRetailersStripSkeleton = () => (
    <div className="mb-16">
        <div className="skeleton h-12 w-80 mb-8"/>
        <div className="flex flex-wrap gap-8">
            {Array.from({length: 2}).map((_, i) => (
                <div key={i} className="skeleton w-[200px] h-32 rounded-3xl"/>
            ))}
        </div>
    </div>
);

export const PopularRetailersStrip = ({loading}) => {
    if (loading) return <PopularRetailersStripSkeleton/>;
    if (!Array.isArray(retailers) || retailers.length === 0) return null;

    return (
        <div className="mb-16">
            <h2 className="text-4xl font-black pt-dark-blue mb-8">
                Popular Retailers
            </h2>

            <div className="flex flex-wrap gap-8">
                {retailers.map((r) => (
                    <a
                        key={r.id}
                        href={r.href}
                        className="bg-white rounded-3xl border border-base-200 shadow-sm hover:shadow-md transition-all p-8 flex items-center justify-center w-[200px] h-32 no-underline group"
                    >
                        <img
                            src={r.logo}
                            alt={r.alt}
                            className="max-w-full max-h-full object-contain transition-transform group-hover:scale-105"
                            loading="lazy"
                        />
                    </a>
                ))}
            </div>
        </div>
    );
};